(() => {
  if (window.otfAppearance?.controllerReady) return;
  const root = document.documentElement;
  const key = 'otf-appearance-v1';
  const valid = value => value === 'light' || value === 'dark' || value === 'system';
  let preference = valid(root.dataset.otfAppearancePreference) ? root.dataset.otfAppearancePreference : 'system';
  let systemQuery = null;
  try { systemQuery = window.matchMedia('(prefers-color-scheme: dark)'); } catch (error) {}
  let motionQuery = null;
  let forcedColorsQuery = null;
  try {
    motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    forcedColorsQuery = window.matchMedia('(forced-colors: active)');
  } catch (error) {}
  const animations = new Set();
  let lastAnimation = -Infinity;
  const state = window.otfAppearance || {};
  window.otfAppearance = state;
  state.key = key;
  state.controllerReady = true;

  function render() {
    const resolved = preference === 'system' ? (systemQuery?.matches ? 'dark' : 'light') : preference;
    root.dataset.otfAppearancePreference = preference;
    root.dataset.otfAppearance = resolved;
    root.style.colorScheme = resolved;
    state.preference = preference;
    state.resolved = resolved;
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.content = meta.getAttribute(resolved === 'dark' ? 'data-otf-dark' : 'data-otf-light') || (resolved === 'dark' ? '#151515' : '#ffffff');
    document.querySelectorAll('[data-otf-appearance-select]').forEach(select => {
      if (select.value !== preference) select.value = preference;
      const control = select.closest('[data-otf-appearance-control]');
      if (control) control.hidden = false;
    });
    document.querySelectorAll('[data-otf-appearance-toggle]').forEach(button => {
      button.setAttribute('aria-pressed', String(resolved === 'light'));
      button.title = (resolved === 'dark' ? button.dataset.otfSwitchToLight : button.dataset.otfSwitchToNight) || button.getAttribute('aria-label') || '';
      button.hidden = false;
    });
  }

  function cancelAnimations() {
    animations.forEach(animation => animation.cancel());
    animations.clear();
  }

  function setPreference(next) {
    cancelAnimations();
    preference = next;
    try { window.localStorage.setItem(key, preference); } catch (error) {}
    render();
  }

  function animateBulb(button, light) {
    const now = window.performance.now();
    if (motionQuery?.matches || forcedColorsQuery?.matches || now - lastAnimation < 800 || typeof button.animate !== 'function') return;
    lastAnimation = now;
    const frames = light ? [{ opacity: 0 }, { opacity: 1 }] : [{ opacity: 1 }, { opacity: 0 }];
    button.querySelectorAll('.otf-bulb__filament, .otf-bulb__glow').forEach(element => {
      const animation = element.animate(frames, { duration: 120, easing: 'ease-out' });
      animations.add(animation);
      animation.onfinish = animation.oncancel = () => animations.delete(animation);
    });
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-otf-appearance-toggle]');
    if (!(button instanceof HTMLButtonElement) || button.disabled || button.hidden) return;
    const next = state.resolved === 'dark' ? 'light' : 'dark';
    setPreference(next);
    animateBulb(button, next === 'light');
  });
  document.addEventListener('change', event => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || !select.matches('[data-otf-appearance-select]')) return;
    if (!valid(select.value)) { render(); return; }
    setPreference(select.value);
  });
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    let next = event.key === null ? null : event.newValue;
    preference = valid(next) ? next : 'system';
    cancelAnimations();
    render();
  });
  const onSystemChange = () => { if (preference === 'system') { cancelAnimations(); render(); } };
  if (systemQuery?.addEventListener) systemQuery.addEventListener('change', onSystemChange);
  else if (systemQuery?.addListener) systemQuery.addListener(onSystemChange);
  [motionQuery, forcedColorsQuery].forEach(query => {
    if (query?.addEventListener) query.addEventListener('change', cancelAnimations);
    else if (query?.addListener) query.addListener(cancelAnimations);
  });
  document.addEventListener('shopify:section:load', () => { cancelAnimations(); render(); });
  render();
})();

